import { providers } from '../../providers';
import type { TersaImageModel } from '../types';
import { defaultSizeNotes } from '../tools';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const klingModels: Record<string, TersaImageModel> = {
    'kling-image-v3': {
        chef: providers.kling,
        providers: [
            {
                ...providers.kling,
                model: undefined,
                model_create: wavespeed.image('kwaivgi/kling-image-v3/text-to-image'),
                model_edit: wavespeed.image('kwaivgi/kling-image-v3/edit'),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '').toUpperCase();
                    if (resolution === '1K') return 0.028 * COST_FACTOR;
                    if (resolution === '2K') return 0.042 * COST_FACTOR;
                    return 0.042 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '1x1', '4x3', '3x4', '3x2', '2x3', '21x9'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['16x9', '9x16', '1x1', '4x3', '3x4', '3x2', '2x3', '21x9'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'kling-image-o3': {
        chef: providers.kling,
        providers: [
            {
                ...providers.kling,
                model: undefined,
                model_create: wavespeed.image('kwaivgi/kling-image-o3/text-to-image'),
                model_edit: wavespeed.image('kwaivgi/kling-image-o3/edit'),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '').toUpperCase();
                    if (resolution === '1K') return 0.028 * COST_FACTOR;
                    if (resolution === '2K') return 0.042 * COST_FACTOR;
                    if (resolution === '4K') return 0.056 * COST_FACTOR;
                    return 0.056 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '1x1', '4x3', '3x4', '3x2', '2x3', '21x9'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '1x1', '4x3', '3x4', '3x2', '2x3', '21x9'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};